import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import RippleLoader from "../../../components/loader/RippleLoader";
import { Form, Formik } from "formik";
import ReactSelect from "react-select";
import ConfirmationModel from "../../../components/common/ConfirmationModel";
import {
  companiesStaff,
  createStaffTransfer,
  createTransfer,
  getEquipment,
  getOutlet,
} from "../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";

const AddEditTransfer = ({ onClose, transferData, mode, companyId }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  //Selector
  const { outletList } = useSelector((store) => ({
    outletList: store?.companiesData?.getOutletStatus?.data?.data,
  }));

  useEffect(() => {
    dispatch(
      getOutlet({
        pageLimit: "all",
        search: "",
        company_id: companyId || transferData?.company_id || "",
        sort_by: "name",
        sort_direction: "asc",
      })
    );
  }, []);

  const outletOptions = outletList?.map((technician) => ({
    label: technician?.name,
    value: technician?.id,
  }));

  const handleFormSubmit = async (values) => {
    const payload = {
      id: transferData?.id,
      outlet_id: values?.outlets?.value,
    };
    setIsLoading(true);
    try {
      let res;
      if (mode === "Staff") {
        res = await dispatch(createStaffTransfer(payload));
      } else {
        res = await dispatch(createTransfer(payload));
      }

      if (
        res?.type === "createStaffTransfer/fulfilled" ||
        res?.type === "createTransfer/fulfilled"
      ) {
        setShowConfirmationModal(false);
        onClose();

        setTimeout(() => {
          if (mode === "Staff") {
            dispatch(
              companiesStaff({
                search: "",
                roles: "",
                pageCount: 1,
                pageLimit: 10,
                sort_by: "",
                sort_direction: "desc",
                types: "",
                outlet: "",
                company_id: companyId || "",
              })
            );
          } else {
            dispatch(
              getEquipment({
                search: "",
                pageCount: 1,
                pageLimit: 10,
                sort_by: "",
                sort_direction: "desc",
                equipment: "",
                outlet: "",
                company_id: companyId,
              })
            );
          }
        }, 300);
      }
    } catch (error) {
      console.error("Form submission failed:", error);
    } finally {
      setIsLoading(false);
      setShowConfirmationModal(false);
    }
  };

  return (
    <>
      <div className="model" onClick={onClose}>
        <div
          className="bg-white items-center justify-center drop-shadow-lg rounded-lg w-full max-w-xl py-8 px-6 mx-auto relative"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h4 className="font-Montserrat text-3xl font-normal">
            {`Transfer of ${mode === "Staff" ? "Staff" : "Equipment"}`}
          </h4>
          <p className="font-Proxima text-base font-normal mt-2">
            Current Outlet: {transferData?.outlet?.name || "-"}
          </p>
          {isLoading ? (
            <RippleLoader />
          ) : (
            <Formik
              enableReinitialize={true}
              initialValues={{
                technician: null,
                role: null,
                outlets: [],
              }}
              validationSchema={Yup.object().shape({
                outlets: Yup.object().required("Outlet is required"),
              })}
              onSubmit={(values) => {
                setFormValues(values);
                setShowConfirmationModal(true);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                resetForm,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="mb-4 mt-3">
                    <ReactSelect
                      className={"w-full text-black p-0 font-Proxima"}
                      id="role"
                      placeholder="New Outlet Location"
                      options={outletOptions}
                      getOptionValue={(option) => option?.value}
                      getOptionLabel={(option) => option?.label}
                      value={values.outlets}
                      onChange={(option) => setFieldValue("outlets", option)}
                      styles={{
                        control: (base) => ({
                          ...base,
                          border: `1px solid #0000003B`,
                          borderColor: "#0000003B",
                          borderRadius: "0.3rem",
                          boxShadow: "none",
                          "&:hover": {
                            border: "1px solid #0000003B",
                          },
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isSelected
                            ? "#F15B29"
                            : "white",
                          "&:active": {
                            backgroundColor: state.isSelected
                              ? "#F15B29"
                              : "rgba(0, 0, 0, 0.04)",
                          },
                        }),
                      }}
                    />
                  </div>

                  {/* Submit button */}
                  <div className="flex justify-end gap-3 mt-3 w-full">
                    <button
                      onClick={onClose}
                      type="button"
                      className=" text-themeBtn w-full flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
                    >
                      <span>Cancel</span>
                    </button>
                    <button
                      type="submit"
                      className="flex items-center w-full justify-center px-6 py-1.5 rounded font-Montserrat uppercase border-2 border-themeBtn  text-white bg-themeBtn"
                      // onClick={onConfirm}
                    >
                      <span>Confirm</span>
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
        {showConfirmationModal && (
          <div>
            <ConfirmationModel
              confirmText={"Create"}
              onClose={() => setShowConfirmationModal(false)}
              onConfirm={() => handleFormSubmit(formValues)}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default AddEditTransfer;
